<template>
    <div class="outer-wrapper">
    <div class='wrap'>
            <div class='title'>
                    <p class="title-right title-text">欢迎注册成为本网站会员！</p>
                    <p class="title-left title-text" @click="toHome">返回主页</p>
                    <div class="arrow" @click="toHome"></div>
                </div>
                <div class="login-logo">
                        <img class='login-logo-img' :src="logoImgUrl" alt='' />
                        </div>
        <div class='main'>
            <div class='main-input'>
                <Tooltip class="tooltip-item" theme="light" content="*建议用手机号或邮箱注册，或6～16位字符" placement="right">
                    <el-input @focus="handleRewrite" class='m-i' placeholder="设置用户名（手机号/邮箱）" v-model="values.account" clearable><i slot="suffix" class=""></i></el-input>
                </Tooltip>
                <Tooltip class="tooltip-item" theme="light" content="*6～20位字符或数字" placement="right">
                <el-input type="password" @focus="handleRewrite" class='m-i' placeholder="设置您的登录密码" v-model="values.password" clearable><i slot="suffix" class=""></i></el-input>
                </Tooltip>
                <Tooltip class="tooltip-item" theme="light" content="*请再次输入您的密码" placement="right">
                <el-input type="password" @focus="handleRewrite" class='m-i' placeholder="请再次输入您的密码" v-model="values.password_confirm" clearable><i slot="suffix" class=""></i></el-input>
                </Tooltip>
                <Tooltip class="tooltip-item" theme="light" content="请输入真实姓名" placement="right">
                    <el-input @focus="handleRewrite" class='m-i' placeholder="真实姓名" v-model="values.full_name" clearable><i slot="suffix" class=""></i></el-input>
                </Tooltip>
                <div class='error-box m-i' v-show="errorFlag.isCode"><span><i class=""></i></span><span class="error-text">{{errorFlag.text}}</span></div>
                <el-button class='m-i m-bt' type="primary" plain @click="toRegister">同意条款并注册</el-button>
                <el-checkbox  class="m-i m-protocol" v-model="checked" @change="handleRewrite">我已阅读并同意<a href="">《会员注册协议》</a></el-checkbox>
            </div>
            <div class='footer'>
                    <span class="f-text"><router-link :to="{path:'/login'}">已有帐号，去登录</router-link></span>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        name: "registerBox",
        data() {
            return {
                values: {
                    account: "",
                    password: "",
                    password_confirm:"",
                    full_name:"",
                },
                errorFlag: {
                    isCode: false,
                    text: ""
                },
                checked:false,
                logoImgUrl: process.env.BASE_URL + "img/login_logo.png",
            }
        },
        props: {
        },
        created() {
        },
        mounted() {
        },
        methods: {
            //非空验证
            handleRewrite(){
                this.errorFlag.isCode = false;
            },
            checkVal() {
                if (this.values.account=="") {
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "用户名不能为空";
                } else if(this.values.password==""){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "密码不能为空";
                }else if(this.values.password_confirm==""){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "请再次输入密码";
                }else if(this.values.password_confirm!==this.values.password){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "两次密码不同请重新设置";
                    this.values.password_confirm = "";
                    this.values.password = "";
                }else if(this.checked == false){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "请勾选同意《会员注册协议》选项";
                }
            },

            checkValFormat() {
                if(this.values.account.length<=4||this.values.account.length>17){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "用户名长度不符合要求";
                }else if(this.values.password.length<=5||this.values.password.length>20){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "密码长度不符合要求";
                }else if(this.values.password.indexOf(' ')!==-1){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "密码内包含非法字符，请重新设置";
                }

            },
            toHome(){
                location.href = "/";
            },

            toRegister() {
                this.checkVal();
                this.checkValFormat();
                if(this.errorFlag.isCode){
                    return true;
                }
                this.$axios.post(this.$url + '/register', {
                    val: this.values
                }).then(response => {
                    if (response.data.error_info !== '') {
                        this.errorFlag.isCode = true;
                        this.errorFlag.text = response.data.error_info;
                    } else {
                        location.href="/login";
                    }
                }).catch(error => {
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = error+"注册失败！";
                });
                /**$ajax.post('/login',{
                    val:this.values
                }).then(function(response){
                    this.handlerCookie();
                    location.href="/";
                }).catch(function(error){
                    this.errorFlag.isCode = true;
                    this.errorFlag.text = "账号或密码错误！";
                })**/
            },
        }
    }
</script>


<style scoped>
    .outer-wrapper{
        width:100%;
        position: relative;
        background: #eee;
        padding: 8% 0 15% 0;       
    }
        .wrap {
            width: 800px;
            margin: 0 auto;
            background: #fff;
            border-radius: 5px;
            position: relative;
        }
    
        .main {
            position: relative;
            left:450px;
            width:250px;
            padding: 50px 0 60px 0;
        }
        .title{
            height:40px;
        }
        .title-text{
            font-size: 18px;
            font-weight: 600;
            font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        }
        .m-i{
            margin:10px 0;
            width:250px;       
        }
        .m-bt {
        width: 100%;
        background-color: #993333;
        color:#ddd;
        border:none;
    }

    .m-bt:hover{
        background-color: #993333;
        border:none;
        color:#fff;
    }
        .error-box{
            color:red;
            font-size: 12px;
            text-align: left;
            margin-left:2px; 
        }
        .footer{
            text-align: right;
            height:30px;
            line-height: 30px;
        }
        .f-text{
            color:#999;
            font-size: 12px;
            margin-right:20px; 
        }
        .m-protocol{
            color:#999;
        }
        .title {
        height: 36px;
        background-color: #993333;
        position: relative;
    }

    .title-text {
        font-size: 12px;
        color:#ddd;
        line-height: 40px;
        position: absolute;
    }

    .title-right{
        right:24px;
    }

    .title-left{
        left:24px;
        cursor: pointer;
    }
    .login-logo{
        padding: 40px 0;
        position: absolute;
        left:80px;
        top:150px;

    }

    .login-logo-img{
        width:250px;

    }
    .arrow{
        position: absolute;
        cursor: pointer;
        left:10px;
        top:14px;
        width:10px;
        height: 10px;
        background: url('~@/assets/more1.png');
        background-size: 100% 100%;
    }
    </style>